import { render, staticRenderFns } from "./evaluaciones-retroalimentacion.vue?vue&type=template&id=0a376fa1"
import script from "./evaluaciones-retroalimentacion.vue?vue&type=script&lang=js"
export * from "./evaluaciones-retroalimentacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports